import React from 'react'
import { ControllerRenderProps, FieldValues } from 'react-hook-form'

import { BudgetSearchBarPicker } from './BudgetSearchBarPicker'
import { cn } from '../../../shadcn/utils'

type BudgetPickerInputFieldProps = {
  field: ControllerRenderProps<FieldValues, string>
  isFocused: boolean
  isFromSearchPage: boolean
  revampPicker: boolean
}

export const BudgetPickerInputField: React.FC<BudgetPickerInputFieldProps> = ({
  field,
  isFocused,
  isFromSearchPage,
  revampPicker,
}) => (
  <div
    className={cn(
      'flex w-full cursor-pointer items-center gap-x-[1px] rounded-[5px] px-3',
      isFocused && 'text-black',
    )}
    data-testid='budget-picker'
  >
    <BudgetSearchBarPicker
      field={field}
      isFromSearchPage={isFromSearchPage}
      revampPicker={revampPicker}
    />
  </div>
)
